import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	schedulesCount: {
		id: 'eoc-schedule.ui.section.schedules-count',
		defaultMessage: 'Schedules, {count} schedules',
		description: 'Schedules count label.',
	},
});
